"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHeaderSection = void 0;
exports.defaultHeaderSection = {
    translate: {
        title: 'Property Guides & Useful Information',
        home: 'Home',
        selectGuide: 'Select Guide',
    },
};
